<template>
  <div class="sidebar-footer">
    <div v-if="!isPendingUser" class="user-container">
      <img class="picture" :src="user?.personal_information?.profile_picture_id ? getImage(user.personal_information.profile_picture_id) : getRandomUserPicture(user?.personal_information?.first_name)" alt="picture" />
      <transition name="fade">
        <div v-if="animationIsFinished && sidebarIsOpen" class="identity">
          <span>{{ user.personal_information.first_name }} {{ user.personal_information.last_name }}</span>
          <!-- <small>{{ user.position ? user.position : currentOrganisation.name }}</small> -->
        </div>
      </transition>
    </div>
    <div class="settings-container" :class="{ withSwitch: organisations?.length > 1 }">
      <router-link class="settings-link" :to="{ name: 'profil' }">
        <i class="bi bi-person-lines-fill" />
        <span v-text="$t('app.sidebar.profil')" />
      </router-link>
      <v-select v-if="!isOrganisationsPending && organisations.length > 1" id="campaign-space" :placeholder="$t('app.sidebar.selectSpace')" name="campaign-space" label="details.name" :modelValue="currentOrganisation" :clearable="false" :options="organisations" :searchable="false" @update:modelValue="switchOfCompany">
        <template #selected-option="{ details }">
          <div class="custom-selected-option">
            <i class="bi bi-globe" />
            <span>{{ details.name }}</span>
          </div>
        </template>
        <template #option="{ details }">
          <span>{{ details.name }}</span>
        </template>
        <template v-slot:no-options="{ search, searching }">
          <div style="padding: 8px 0">{{ $t("app.sidebar.noResult") }}{{ searching ? ` ${$t("app.sidebar.for")} ${search}` : "" }}</div>
        </template>
      </v-select>
      <LanguagePicker />
      <div class="grouped-button">
        <Button class="icon icon-left sm full-size" :class="!isDark ? 'secondary' : 'transparent'" :label="$t('other.global.light')" icon="bi bi-sun" @click="toggleDark()" />
        <Button class="icon icon-left sm full-size" :class="isDark ? 'secondary' : 'transparent'" :label="$t('other.global.dark')" icon="bi bi-moon" @click="toggleDark()" />
      </div>
      <Button class="red icon icon-right full-size" :label="$t('other.actions.logout')" icon="bi bi-power" @click="logout(); router.push({ name: 'auth' })" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDark, useToggle } from "@vueuse/core";
import { getImage, getRandomUserPicture } from "@/composables/getImage.js";
import { useRouter } from "vue-router";
import { useOrganisation, useOrganisations } from "@/queries/organisation.query";
import { Organisation } from "@/types/company";
import { useUser, logout } from "@/queries/user.query";
import { queryClient } from "@/queries/queryClient";

const router = useRouter();
const route = useRoute();

const { data: user, isPending: isPendingUser } = useUser();
const { data: organisations, isPending: isOrganisationsPending } = useOrganisations();
const { data: currentOrganisation } = useOrganisation();


defineProps({
  animationIsFinished: {
    type: Boolean,
    required: true,
  },
  sidebarIsOpen: {
    type: Boolean,
    required: true,
  },
});

const isDark = useDark();
const toggleDark = useToggle(isDark);

async function switchOfCompany(selectedOrganisation: Organisation) {
  await router.push({
    name: "home",
    params: { companyId: selectedOrganisation.id },
  });

  await queryClient.invalidateQueries({ queryKey: ["user"] });
  await queryClient.invalidateQueries({ queryKey: ["campaigns"] });
  await queryClient.invalidateQueries({ queryKey: ["spaces"] });
  localStorage.setItem("current_organisation_id", selectedOrganisation.id);
}
</script>
